import { isMacLike } from "@/utils/platform";
import { useCallback, useEffect } from "react";

/**
 * Enables capturing the Cmd/Ctrl + / key to show keyboard shortcuts help
 */
export const useKeyboardHelpShortcut = (setTriggered: (value: boolean) => void) => {
    const handleKeyPress = useCallback(
        (event: KeyboardEvent) => {
            if (event.key !== "/" && event.key !== "?") {
                return;
            }

            if (isMacLike()) {
                if (!event.metaKey) {
                    return;
                }
            } else {
                if (!event.ctrlKey) {
                    return;
                }
            }

            if (event.defaultPrevented) {
                return;
            }
            event.preventDefault();
            setTriggered(true);
        },
        [setTriggered],
    );

    useEffect(() => {
        document.addEventListener("keydown", handleKeyPress);

        return () => {
            document.removeEventListener("keydown", handleKeyPress);
        };
    }, [handleKeyPress]);
};
